
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#D0EFEC","clip-path":"url(#clip0_8585_498)"}},[_c('path',{attrs:{"d":"M8.657 19.288h6.499v3.234h-6.5zM16.07 19.288h6.498v3.234H16.07zM23.482 19.288h6.499v3.234h-6.5zM30.894 19.288h6.499v3.234h-6.499zM8.657 23.435h6.499v3.234h-6.5zM16.07 23.435h6.498v3.234H16.07zM23.482 23.435h6.499v3.234h-6.5zM30.894 23.435h6.499v3.234h-6.499zM8.657 27.582h6.499v3.234h-6.5zM16.07 27.582h6.498v3.234H16.07zM23.482 27.582h6.499v3.234h-6.5zM8.657 31.729h6.499v3.233h-6.5zM16.07 31.729h6.498v3.233H16.07z"}})]),_c('path',{attrs:{"stroke":"#234652","stroke-width":".999","d":"M5 16.217h35.969"}}),_c('path',{attrs:{"stroke":"#234652","stroke-linecap":"square","stroke-width":".999","d":"M26.482 39.198H5.5V10.223h6.858M41.47 28.625V10.223h-6.687m-6.531 0h-9.58"}}),_c('rect',{attrs:{"width":"2.997","height":"6.994","x":"13.992","y":"6.725","stroke":"#234652","stroke-width":".999","rx":"1.499"}}),_c('rect',{attrs:{"width":"2.997","height":"6.994","x":"29.979","y":"6.725","stroke":"#234652","stroke-width":".999","rx":"1.499"}}),_c('path',{attrs:{"stroke":"#234652","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10","stroke-width":".999","d":"m40.283 35.576-4.221 4.221-1.948-1.948m9.741-.65a6.494 6.494 0 1 1-12.989 0 6.494 6.494 0 0 1 12.99 0"}}),_c('path',{attrs:{"fill":"#D0EFEC","d":"M30.903 27.58H37.4v.92s-2.12-.026-3.4.5c-1.029.423-2.57 1.82-2.57 1.82h-.53zM23.48 31.73h6.51l-.01.84s-.77.461-.98.93-.1 1.47-.1 1.47h-5.42z"}}),_c('defs',[_c('clipPath',{staticClass:"i-clip0_8585_498"},[_c('path',{attrs:{"fill":"#fff","d":"M8.657 19.288h28.737v15.675H8.657z"}})])])])
          )
        }
      }
    